import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import InputCheckbox from '../common/input-checkbox'

type ControlledCheckboxProps<IFormValues extends FieldValues> = {
    label: string
    name: Path<IFormValues>
    control: Control<IFormValues, any>
    required?: boolean
    translationLabel?: any
    dataCy?: string
}

const ControlledCheckbox = <IFormValues extends FieldValues>({
    label,
    name,
    control,
    required = false,
    translationLabel,
    dataCy,
}: ControlledCheckboxProps<IFormValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <InputCheckbox
                    label={label}
                    error={fieldState.error?.message as any}
                    value={field.value}
                    required={required}
                    onChange={(value) => field.onChange(value as any)}
                    translationLabel={translationLabel}
                    dataCy={dataCy}
                />
            )}
        />
    )
}

export default ControlledCheckbox
